import { subDays } from "date-fns";
 
 export  const dateformation = (date) => {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return ''; // In case of an invalid date
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = parsedDate.getDate().toString().padStart(2, '0');
    const year = parsedDate.getFullYear();

    return `${month}/${day}/${year}`;
}
 export  const dateformation2 = (date) => {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return ''; // In case of an invalid date
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = parsedDate.getDate().toString().padStart(2, '0');
    const year = parsedDate.getFullYear();

    return `${month}-${day}-${year}`;
}


export function getDurationInDays(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    
    const diff = Math.abs(end - start); // Difference in milliseconds
    const days = diff / (1000 * 60 * 60 * 24);
    
    return days + 1;
}




export const minusOneDay=(myDate)=>{
    const date = new Date(myDate);
const newDate = subDays(date, 1);
return newDate
}


export function convertDateFormat(dateStr) {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
}


